import api from "./index";
import type { DeviceRecord, ReminderPrefs } from "./types";

export const devicesApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getPushConfig: builder.query<{ vapidPublicKey: string | null; phonePush: boolean }, void>({
      query: () => ({ url: "/devices/config" }),
    }),
    registerDevice: builder.mutation<{ device: DeviceRecord }, { subscription?: unknown; token?: string; platform: string; label: string; timeZone: string; reminders: ReminderPrefs }>({
      query: (body) => ({ url: "/devices", method: "POST", body }),
      invalidatesTags: ["Devices"],
    }),
    removeDevice: builder.mutation<{ ok: boolean }, { endpoint?: string; token?: string }>({
      query: (body) => ({ url: "/devices/remove", method: "POST", body }),
      invalidatesTags: ["Devices"],
    }),
    testDevice: builder.mutation<{ outcome: string }, { endpoint?: string; token?: string }>({
      query: (body) => ({ url: "/devices/test", method: "POST", body }),
    }),
    getDevices: builder.query<{ devices: DeviceRecord[] }, void>({
      query: () => ({ url: "/devices" }),
      providesTags: ["Devices"],
    }),
  }),
});

export const { useGetPushConfigQuery, useRegisterDeviceMutation, useRemoveDeviceMutation, useTestDeviceMutation, useGetDevicesQuery } = devicesApi;
